import React from "react";
import BookingForm from "../BookingForm";
import Reveal from "../Reveal";

export default function BookingSection() {
  return (
    <section id="book" className="bg-gold-soft/40 py-20 scroll-mt-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <h2 className="font-display text-3xl sm:text-4xl text-ink">Book a Free Site Visit</h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Fill this out and we'll confirm eligibility and contact you to arrange the best time.
          </p>
        </Reveal>
        <Reveal delay={80}>
          <div className="mt-10 rounded-2xl border border-gold/25 bg-white p-6 sm:p-9 shadow-[0_20px_60px_rgba(0,0,0,0.08)]">
            <BookingForm />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
